import { render } from "./ButtonToggleBody.vue?vue&type=template&id=14229982&scoped=true"
import script from "./ButtonToggleBody.vue?vue&type=script&lang=js"
export * from "./ButtonToggleBody.vue?vue&type=script&lang=js"

import "./ButtonToggleBody.vue?vue&type=style&index=0&id=14229982&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14229982"]])

export default __exports__